import { profileFragment, userDataFragment, planFragment } from "./gql.fragments";

export const getSubscriptionQuery = () => `
    query subscription {
        user: users {
            ...UserData
            profile: profiles {
                ...Profile
            }
            planChanges {
                id
                plan {
                  id
                  segmentId
                }
                expireDate
            }
            addresses {
              id
              isActive
              city
              country
              region
              regionId
              postcode
              telephone
              street
              instruction
            }
            availableDeliveryDays {
              day
              label
              value
            }
        }
        plans (order: "price"){
            id
            title
            price
            deliveryFee
            discountPrice
            mealsPerDelivery
            deliveries
            productDiscountRate
            planGiftId
            segmentId
            deliveryType {
              id
              name
            }
            available
            featured
            type
          }
    }
    ${userDataFragment()}
    ${profileFragment()}
`

export const getPlansQuery = () => `
  query getAvailablePlans($zipcode: String) {
    availablePlans(zipcode: $zipcode, featured: true) {
      ...Plan
    }
  }
  ${planFragment()}
`